export default "__VITE_ASSET__BZFk5wRC__"